// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tablist_tabs__NmiJP","tabList":"tablist_tabList__d58Ri","botons":"tablist_botons__vjGtv"};